module.exports = __webpack_public_path__ + "img/tu11.d41054b6.png";